import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-notification-push',
  templateUrl: './notification-push.component.html',
  styleUrls: ['./notification-push.component.scss'],
})
export class NotificationPushComponent implements OnInit {

  @Input('description') description: string;
  @Input('image') image: any;

  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {}

  dismiss(value){
    this.modalCtrl.dismiss({ confirm: value }, '', 'modalNotificationPush');
  }

}
